/* eslint-disable react/jsx-pascal-case */
import timeLineStyle from "../../DetailContainer.module.scss";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { PiCalendarThin } from "react-icons/pi";
import { getCandidateTimeline } from "../../../../services/candidateServices";
import {
  capitalizeWords,
  dateFormateDD,
  Ddmmmyyyy_date,
  textTruncate,
  formatDescription,
} from "../../../../utility";
import { CgUser } from "react-icons/cg";
import { FaUser } from "react-icons/fa6";
import { FormControl, MenuItem, Select } from "@mui/material";

const TimelineView = ({ candidateId, isLead }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });

  const [page, setPage] = useState(1);
  const [size] = useState(10);
  const [hasMore, setHasMore] = useState(true);

  const [eventType, setEventType] = useState("");

  // ✅ API CALL
  const fetchTimeline = async (reset = false, pageNo = page) => {
    try {
      const res = await getCandidateTimeline({
        [isLead ? "can_lead_id" : "candidate_id"]: candidateId,
        event_type: eventType,
        page: pageNo,
        size,
      });

      const newData = res?.data || [];

      setTimelineData((prev) => (reset ? newData : [...prev, ...newData]));

      setHasMore(newData.length === size);
    } catch (err) {
      console.error(err);
    }
  };

  // ✅ initial + filter change
  useEffect(() => {
    setPage(1);
    fetchTimeline(true, 1);
  }, [eventType]);

  // ✅ pagination
  useEffect(() => {
    if (page !== 1) fetchTimeline(false, page);
  }, [page]);

  const handleClick = (e, id) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();

    const POPUP_WIDTH = 520;
    const RIGHT_MARGIN = 10;

    let left = window.innerWidth - POPUP_WIDTH - RIGHT_MARGIN;

    let top = rect.top + rect.height / 2 - 80;

    if (top < 60) top = 60;

    if (top + 300 > window.innerHeight) {
      top = window.innerHeight - 320;
    }

    setPopoverPos({
      top,
      left,
    });

    setSelectedItem(id);
  };

  const handleClose = () => {
    setSelectedItem(null);
  };

  const activeItem = timelineData.find((item) => item.id === selectedItem);

  return (
    <>
      {/* HEADER */}
      <div
        // className="sticky-top "
        style={{
          background: "#f2f2f2",
          borderRadius: "16px 16px 0 0",
        }}
        
      >
        <div className={`me-2 ${timeLineStyle.header}`}>
          <div className={timeLineStyle.headertitle}>Timeline</div>

          {/* FILTER */}
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select
              value={eventType}
              onChange={(e) => setEventType(e.target.value)}
              displayEmpty
              sx={{
                backgroundColor: "#fff",
                borderRadius: "8px",
                height: "36px",
              }}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="MAIN">Main</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      {/* TIMELINE */}
      <div className={timeLineStyle.timelineContainer}>
        <div className={timeLineStyle.scrollContainer}>
          {timelineData.map((item, index) => (
            <div
              key={item.id}
              className={`${timeLineStyle.timelineItem} ${
                selectedItem === item.id ? timeLineStyle.timelineactive : ""
              }`}
              onClick={(e) => handleClick(e, item.id)}
            >
              {/* LEFT */}
              <div className={timeLineStyle.leftContent}>
                <div className={timeLineStyle.date}>
                  {<Ddmmmyyyy_date dateValue={item.created_time} />}
                </div>
              </div>

              {/* CENTER */}
              <div className={timeLineStyle.centerIcon}>
                <div
                  className={`${timeLineStyle.iconWrapper} ${
                    item.event_type === "MAIN" ? timeLineStyle.largeIcon : ""
                  }`}
                >
                  <FaUser />
                </div>

                {index !== timelineData.length - 1 && (
                  <div className={timeLineStyle.lineBar}></div>
                )}
              </div>

              {/* RIGHT */}
              <div className={timeLineStyle.rightContent}>
                <div className={timeLineStyle.title}>{item.event_name}</div>

                {item.event_description && (
                  <div
                    className={timeLineStyle.description}
                    dangerouslySetInnerHTML={{
                      __html: formatDescription(item.event_description),
                    }}
                  />
                )}

                {item.notes && (
                  <div className={timeLineStyle.description}>
                  <b>NOTE :</b>  {textTruncate(capitalizeWords(item.notes), 60)}
                  </div>
                )}
                <div className={timeLineStyle.author}>
                  by{" "}
                  <span className={timeLineStyle.assignedTo}>
                    <span className={timeLineStyle.assignedminiSize}>
                      {(item.user_name || "No Admin").charAt(0).toUpperCase()}
                    </span>

                    <span className={timeLineStyle.assignedname}>
                      {item.user_name || "No Admin"}
                    </span>
                  </span>
                </div>
              </div>

              {/* POPUP */}
              {activeItem?.id === item.id && (
                <div
                  className={timeLineStyle.popover}
                  style={{
                    position: "fixed", // ✅ IMPORTANT
                    top: popoverPos.top,
                    left: popoverPos.left,
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="d-flex justify-content-between">
                    <span>
                      <h6>Details</h6>
                    </span>

                    <AiOutlineClose
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation(); // ✅ FIX 2
                        handleClose();
                      }}
                    />
                  </div>

                  <div className="d-flex flex-column">
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px 10px 1fr",
                        alignItems: "start",
                        padding: "10px",
                        rowGap: "15px",
                      }}
                    >
                      {/* Event */}
                      <span>Event</span>
                      <span>:</span>
                      <strong>{activeItem.event_name}</strong>

                      {/* Description (only if exists) */}
                      {activeItem.event_description && (
                        <>
                          <span>Description</span>
                          <span>:</span>
                          <strong>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: formatDescription(
                                  item.event_description,
                                ),
                              }}
                            />
                          </strong>
                        </>
                      )}
                      {activeItem.notes && (
                        <>
                          <span>Notes</span>
                          <span>:</span>
                          {/* <strong> */}
                            <div className={timeLineStyle.description}>
                              {activeItem.notes}
                            </div>
                          {/* </strong> */}
                        </>
                      )}

                      {/* Event On */}
                      <span>Event On</span>
                      <span>:</span>
                      <strong>
                        {" "}
                        {<Ddmmmyyyy_date dateValue={activeItem.created_time} />}
                      </strong>

                      {/* Action by */}
                      <span>Action by</span>
                      <span>:</span>
                      <strong>
                        <span className={timeLineStyle.assignedTo}>
                          <span className={timeLineStyle.assignedminiSize}>
                            {(activeItem.user_name || "No Admin")
                              .charAt(0)
                              .toUpperCase()}
                          </span>

                          <span className={timeLineStyle.assignedname}>
                            {activeItem.user_name || "No Admin"}
                          </span>
                        </span>
                      </strong>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}

          {/* LOAD MORE */}
          {hasMore && (
            <div className="text-center p-2">
              <button
                onClick={() => setPage((p) => p + 1)}
                className={timeLineStyle.primaryButton}
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TimelineView;
